import React from "react";
import "./App.css";
import "animate.css";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import Contact from "./Contact/Contact";
import Technolo from "./Technolo/Technolo";
import Home from "./Home/Home";
import Aboutus from "./Aboutus/Aboutus";
import Ourwork from "./Ourwork";
import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import ReactNative from "./ReactNative";
import Blogs from "./Blogs";
import Addblog from "./Addblog";
function App() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(true);
    }, 10);
    return () => clearTimeout(timeoutId);
  }, []);

  const findMaxpId = () => {
    const newData = [...blog].map((data) => data.bid);
    console.log(newData);
    console.log(Math.max(...newData));
    return Math.max(...newData);
  };

  const [blog, setblog] = useState([
    // {
    //   bid: 1,
    //   Title: "This is dummy blog",
    //   Description: "svfdavdvdsvdsv",
    //   Date: "02-11-1998",
    //   Image:
    //     "https://media.licdn.com/dms/image/D4D10AQGWaurs3-Z2iw/image-shrink_800/0/1689258604913?e=1689865200&v=beta&t=yDZfShIdxDyivDLH0g1B_Jp3g4xOpcCJeGmUJG4JA0o",
    // },
  ]);

  const addnewblog = (Title, Description, Date, Image,link,) => {
    const formatblog = [...blog];
    let newformatblog = {
      bid: findMaxpId() + 1,
      Title,
      Description,
      link,
      Date,
      Image,
    };
    formatblog.push(newformatblog);
    setblog(formatblog);
  };
  return (
    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Aboutus" element={<Aboutus />} />
        <Route path="/Contactus" element={<Contact />} />
        <Route path="/Blogs" element={<Blogs sendblog={blog} />} />
        <Route path="/Addblog" element={<Addblog ab={addnewblog} />} />
        <Route path="/Technolo" element={<Technolo />} />
        <Route path="/Ourwork" element={<Ourwork />} />
        <Route path="/ReactNative" element={<ReactNative />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
